import { Component, OnDestroy, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OtherVerificationMethodsComponent } from './other-verification-methods/other-verification-methods.component';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { AuthStorageService } from '../auth/auth-storage.service';
import { Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-verify-identity',
  templateUrl: './verify-identity.component.html',
  styleUrls: ['./verify-identity.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('accordionAnimation', [
      state('void', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('*', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      transition('void <=> *', animate('200ms ease-in-out')),
    ])
  ]
})
export class VerifyIdentityComponent implements OnInit, OnDestroy {
  identityForm: any;
  selectedMethod: string = '';
  verify: boolean = false;
  preferredMethod: boolean = false;
  isOptInChecked: boolean = false;
  isSmsHidden: boolean = false;
  disabledSmsMfaOption: string = 'false';
  maskedEmail: string = '';
  maskedPhone: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private dialogMethods: MatDialog,
    public authService: AuthenticationService,
    private authStorage: AuthStorageService,
  ) { }

  ngOnInit() {
    this.maskedEmail = this.authService.getMaskedEmail();
    this.maskedPhone = this.authService.getMaskedPhone();
    this.authService.getIsSmsHidden$().subscribe((isHidden) => {
      this.isSmsHidden = isHidden;
    });
    this.getDisabledSmsMfaOption();
  }

  async getDisabledSmsMfaOption() {
    this.disabledSmsMfaOption = await this.authService.getdisabledSmsMfaOptionValue()
  }

  onVerificationMethodChange(method: string) {
    this.selectedMethod = method;
    console.log('Selected Method:', this.selectedMethod);
  }

  onPreferredMethodChange(checked: boolean) {
    this.preferredMethod = checked;
  }

  async verifyIdentity() {
    this.verify = true
    console.log('Selected Method:', this.selectedMethod);
    const email = await this.authStorage.getAuthToken('email') || '';
    const mfaToken = await this.authStorage.getAuthToken('mfa_token') || '';
    this.authService.verifyIdentity(mfaToken, this.selectedMethod, email, this.preferredMethod.toString()).subscribe({
      next: (res) => {
        this.verify = false
        this.authService.setMfaMethod(this.selectedMethod);
        this.authStorage.saveAuthToken('oob_code', res.oob_code);
        this.router.navigate(['/verify-code']);
      },
      error: (err) => {
        this.verify = false;
        console.error(err);
      }
    });
  }

  tryOtherMethods() {
    this.dialogMethods.open(OtherVerificationMethodsComponent, {
      width: '400px',
      height: 'auto',
      panelClass: 'verificationMethods-dialog-container'
    });
  }

  toggleOptInCheckbox() {
    this.isOptInChecked = !this.isOptInChecked;
  }

  isPreferredInfoExpanded: boolean = false;
  togglePreferredInfoAccordion() {
    this.isPreferredInfoExpanded = !this.isPreferredInfoExpanded;
  }

  ngOnDestroy(): void {
    this.verify = false
  }
}
